<template>
    <BCard>
    <ValidationObserver ref="form">
        <BForm @submit.prevent="update">
            <BRow>
                <BCol>
                    <ValidationProvider #default="validationContext" :name="$t('Name')" rules="required">
                        <BFormGroup :label="$t('Name')" label-for="name">
                            <BFormInput id="name" v-model="section.name" />
                            <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </BFormInvalidFeedback>
                        </BFormGroup>
                    </ValidationProvider>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BButton class="mb-1 mb-sm-0 mr-0 mr-sm-1" variant="primary" type="submit" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Save Changes') }} </BButton>
                    <BButton variant="outline-secondary" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="cancel"> {{ $t('Cancel') }} </BButton>
                </BCol>
            </BRow>
        </BForm>
    </ValidationObserver>
  </BCard>
</template>

<script>
import { BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { onUnmounted, ref } from '@vue/composition-api';
import { required } from 'vee-validate/dist/rules';
import formValidation from '@core/comp-functions/forms/form-validation'
import sectionsModule from '../sectionsModule'
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store'

export default {
    components: { BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, ValidationObserver, ValidationProvider }, 
    setup() {
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const SECTION_MODULE = 'sections'
        const form = ref(null)
        const section = ref({
            name: ''
        })

        const cancel = function(){ router.push({name: 'sections'}) }

        const update = function(){
            form.value.validate().then(success => {
                if(success) {
                    store.dispatch('sections/updateSection', JSON.parse(JSON.stringify(section.value)))
                        .then(response => { router.push({ name: 'sections' }) })
                        .catch(error => { errorToast() })
                }
            })
        }

        extend('required', required)

        if (!store.hasModule(SECTION_MODULE)) {
            store.registerModule(SECTION_MODULE, sectionsModule)
        }

        onUnmounted(() => {
            if (store.hasModule(SECTION_MODULE)) {
                store.unregisterModule(SECTION_MODULE)
            }
        })

        store.dispatch('sections/fetchSection', { id: router.currentRoute.params.id }).then(response => { 
            section.value = response.data.section
        })

        return {
            getValidationState,
            section,
            cancel,
            update,
            form,
        }
    }
}
</script>